module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Target-fc88b37b22cf08eeb5c078e721b9e0ee.svg";